
import EditComponent from "../../../components/ips/Edit.vue";

export default {
  components: {
    EditComponent
  }
}
